import { createIconComponent } from '../../factory/create-icon-component';
export const BookmarkPlusIcon = createIconComponent(
  'BookmarkPlusIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 22V10C20 7.19974 20 5.79961 19.455 4.73005C18.9757 3.78924 18.2108 3.02433 17.27 2.54497C16.2004 2 14.8003 2 12 2C9.19974 2 7.79961 2 6.73005 2.54497C5.78924 3.02433 5.02433 3.78924 4.54497 4.73005C4 5.79961 4 7.19974 4 10V22L6.27567 20.8622L6.27569 20.8622C8.37459 19.8127 9.42404 19.288 10.5248 19.0815C11.4998 18.8985 12.5002 18.8985 13.4752 19.0815C14.576 19.288 15.6254 19.8127 17.7243 20.8622L17.7243 20.8622L20 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11H15M12 8V14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
